export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const API_BASE = process.env.REACT_APP_API_BASE;
